import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const preRecordedClassesInitialValues = {
  title_video: "",
  url_video: "",
};

export const preRecordedClassesValidationSchema = Yup.object({
  title_video: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  url_video: Yup.string()
    .required(FIELD_REQUIRED_MESSAGE)
    .url("Debe ser una URL válida")
    .test("is-youtube-url", "Debe ser una URL válida de YouTube", (value) => {
      if (!value) return false;
      const youtubeRegex =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|shorts\/)([^#\&\?]*).*/;
      return youtubeRegex.test(value);
    }),
});
